import { Navigate } from "react-router-dom";
import JobsAuthLayout from "../Layout/JobAuthLayout";
import JobsLayout from "../Layout/JobsLayout";
import JobsAuth from "../Pages/JobsAuth";
import JobsSignUp from "../Pages/JobsSign-Up";
import AccountSuccess from "../Pages/AccountSuccess";
import JobResetPassword from "../Pages/JobReset-Password";
import UploadLogo from "../Pages/UploadLogo";
import JobsDashboard from "../Pages/JobsDashboard";
import JobsPosts from "../Pages/JobsPosts";
import ViewJobs from "../Pages/ViewJob";
import ProfileManagement from "../Pages/CompanyProfile";
import CreateJobLayout from "../Layout/CreateJobLayout";
import CreateJobBasics from "../Pages/CreateJob-Basics";
import Compensation from "../Pages/Compensation";
import JobDescription from "../Pages/Job-Description";
import MediaFinalize from "../Pages/Job-Media&Finalize";
import JobsModule from "../modules/JobModules";
import ProtectedRoute from "./ProtectedRoute";

const JobsRoutes = [
  {
    path: "/jobs",
    element: <JobsModule />,
    children: [
      {
        path: "",
        element: <Navigate to="job-admin" replace />,
      },
      {
        path: "job-auth",
        element: <JobsAuthLayout />,
        children: [
          {
            index: true,
            element: <JobsAuth />,
          },
          {
            path: "signup",
            element: <JobsSignUp />,
          },
          {
            path: "account-success",
            element: <AccountSuccess />,
          },
          {
            path: "upload-logo",
            element: <UploadLogo />,
          },
          {
          path: "reset-password",
          element: <JobResetPassword />,
          }
        ],
      },
      {
        path: "job-admin",
        element: (
          <ProtectedRoute>
            <JobsLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <JobsDashboard />,
          },
          {
            path: "job-posts",
            element: <JobsPosts />, // Use the JobsPosts component directly
          },
          {
            path: "job-posts/job-created/:id", // This will match the dynamic :id
            element: <ViewJobs />, // View job with dynamic id
          },

          {
            path: "job-posts/create-job",
            element: <CreateJobLayout />,
            children: [
              {
                index: true,
                element: <CreateJobBasics />,
              },
              {
                path: "compensation",
                element: <Compensation />,
              },
              {
                path: "description",
                element: <JobDescription />,
              },
              {
                path: "media&finalize",
                element: <MediaFinalize />,
              },
            ],
          },
          {
            path: "company-profile",
            element: <ProfileManagement />,
          },
        ],
      },
    ],
  },
];

export default JobsRoutes;
